import React from 'react';

export const OnboardingLoadingSkeleton: React.FC = () => {
  return (
    <div className="mx-6 mt-3 mb-2">
      {/* Loading bar animation */}
      <div className="relative h-1 bg-muted rounded-full overflow-hidden mb-4">
        <div className="absolute inset-0 bg-gradient-to-r from-primary/50 via-primary to-primary/50 animate-[shimmer_1.5s_ease-in-out_infinite]" 
             style={{
               backgroundSize: '200% 100%',
               animation: 'shimmer 1.5s ease-in-out infinite',
             }} 
        />
      </div>
      
      {/* Skeleton content */}
      <div className="rounded-xl border-2 border-primary/20 bg-gradient-to-r from-primary/10 via-primary/5 to-transparent p-4 animate-pulse">
        <div className="flex items-center justify-between gap-4">
          {/* Left side skeleton */}
          <div className="flex items-center gap-4 flex-1">
            <div className="w-12 h-12 rounded-full bg-primary/20" />
            <div className="flex-1 space-y-2">
              <div className="h-4 bg-primary/20 rounded w-32" />
              <div className="h-3 bg-primary/10 rounded w-48" />
            </div>
          </div>
          
          {/* Middle skeleton - steps */}
          <div className="hidden lg:flex items-center gap-3 flex-1">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex flex-col items-center gap-1">
                <div className="w-10 h-10 rounded-full bg-primary/20" />
                <div className="h-2 bg-primary/10 rounded w-16" />
              </div>
            ))}
          </div>
          
          {/* Right side skeleton */}
          <div className="flex items-center gap-3">
            <div className="hidden md:flex flex-col items-end gap-1 min-w-[120px]">
              <div className="h-3 bg-primary/20 rounded w-20" />
              <div className="h-2 bg-primary/10 rounded w-full" />
            </div>
            <div className="w-20 h-8 bg-primary/20 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};
